module.exports = __webpack_public_path__ + "static/media/star_left.3b139152.svg";